export class Client {
  id: number;
  username: string;
  password: string;
  passwordBrute: string;
  name: string;
  phone: string;
  infos: string;
  expiration: string;
  isActive: boolean;
  isDemo: boolean;
  opEmailAlert: boolean;
  email: string;
  opMobileNotification: boolean;
  token: string;
  opDailyReport: boolean;
  RJEmail1: string;
  RJEmail2: string;
  lastConnection: string;
  connectionCounter: number;
  image: string;
  versionApp: string;
  pack: string;
  SendEmailAccess: number;

  constructor() {
    this.isActive = true;
    this.isDemo = false;
    this.opEmailAlert = false;
    this.opMobileNotification = false;
    this.opDailyReport = false;
    this.versionApp = '';
    this.pack = '3'
  }
}



// WEBPACK FOOTER //
// ./src/app/models/client.ts